import React, { useState } from 'react';
import DefaultButton from 'components/Utils/NewDefaultButton';
import './style.scss';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import TopBar from 'scenes/HomePatient2/TopBar';
import Phone from 'react-phone-number-input';
import { useIsLoading, useNavStack } from 'careand-redux/slices/ui/hooks';
import DefaultPatientTextField from 'components/Utils/DefaultPatientTextField';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import { isPossibleNumber } from 'libphonenumber-js';
import EntryView from 'scenes/HomePatient2/PatientEntry/view';
import { getTenantIdentity } from 'hooks/useTenantIdentity';
import TenantImg from '../../../components/TenantImg';

const ForgotUsername = () => {
  const dispatch = useAppDispatch();
  const nav = useNavStack(Stacks.Master);

  const [code, setCode] = useState('');
  const [phone, setPhone] = useState('');
  const [sentCode, setSentCode] = useState(false);
  const [usernames, setUsernames] = useState(undefined);

  const sendingCode = useIsLoading(api.Authentication.recoverUsernameByPhone);
  const confirmingCode = useIsLoading(api.Authentication.verifyUsernameRecovery);

  async function onSubmitPhone(event, resend = false) {
    event.preventDefault();

    const { isSuccess } = await dispatch(
      api.Authentication.newRecoverUsernameByPhone({
        phone,
        resend,
      }),
      { errorTitle: 'Username Recovery', meta: true },
    );
    if (isSuccess) {
      setSentCode(true);
    }
  }

  async function confirmCode(event) {
    event.preventDefault();

    let result = await dispatch(
      api.Authentication.newVerifyUsernameRecovery({
        phone,
        requiredStringResource: { value: code },
      }),
      { errorTitle: 'Username Recovery' },
    );
    if (result) {
      setUsernames(result);
    }
  }

  function onRecoverUsernameSuccess() {
    nav.push('/login');
  }

  return (
    <EntryView className="forgot-username" topContent={<TopBar title="Forgot Username" />}>
      <div className="desktop-only">
        <div className="top-content">
          <TenantImg src="logo_full_color" alt={getTenantIdentity().name} className="logo" />
          <span className="top-text large desktop-only">Forgot Username</span>
        </div>
      </div>

      {sentCode === false && (
        <PhoneForm
          phone={phone}
          setPhone={setPhone}
          onSubmit={onSubmitPhone}
          sendingCode={sendingCode}
        />
      )}
      {sentCode === true && usernames === undefined && (
        <ConfirmCodeForm
          code={code}
          setCode={setCode}
          phone={phone}
          onSubmit={confirmCode}
          confirmingCode={confirmingCode}
          sendingCode={sendingCode}
          onResendCode={(event) => onSubmitPhone(event, true)}
        />
      )}
      {usernames !== undefined && (
        <UsernamesForm usernames={usernames} onRecoverUsernameSuccess={onRecoverUsernameSuccess} />
      )}
    </EntryView>
  );
};

const PhoneForm = ({ phone, setPhone, onSubmit, sendingCode }) => {
  return (
    <>
      <span className="top-text">
        We will send an SMS to this phone to verify your phone number
      </span>
      <form className="forgot-username-form" onSubmit={onSubmit}>
        <Phone placeholder="Phone number" defaultCountry="CA" value={phone} onChange={setPhone} />
        <DefaultButton
          id="forgot-username-send-confirmation"
          name="Send Confirmation Code"
          style={{ width: '100%', marginTop: '27px' }}
          loading={sendingCode}
          disabled={!isPossibleNumber(phone || '')}
        />
      </form>
    </>
  );
};

const ConfirmCodeForm = ({
  phone,
  onSubmit,
  setCode,
  code,
  confirmingCode,
  sendingCode,
  onResendCode,
}) => (
  <>
    <span className="top-text">A confirmation code has been sent to your phone.</span>

    <form id="forgot-username-form" onSubmit={onSubmit}>
      <Phone placeholder="Phone number" defaultCountry="CA" value={phone} disabled={true} />

      <DefaultPatientTextField
        id="forgot-username-confirmation-code"
        name="code"
        value={code}
        label="Confirmation Code"
        onChange={(event) => setCode(event.target.value)}
      />

      <DefaultButton
        id="forgot-username-submit"
        name="Recover Username"
        style={{ width: '100%', marginTop: '27px' }}
        loading={confirmingCode}
      />
    </form>

    <DefaultButton
      name="Resend Code"
      style={{ width: '100%', marginTop: '20px' }}
      className="light"
      loading={sendingCode}
      onClick={onResendCode}
    />
  </>
);

const UsernamesForm = ({ usernames, onRecoverUsernameSuccess }) => (
  <div className="forgot-username-form">
    <span>Below is a list of your {getTenantIdentity().nameShort} usernames:</span>
    <ul className="usernames padded-box">
      {usernames.map((username) => (
        <li className="username">{username.value}</li>
      ))}
    </ul>
    <DefaultButton
      name="Go back to Login screen"
      style={{ width: '100%' }}
      className="blue"
      onClick={onRecoverUsernameSuccess}
    />
  </div>
);

export default ForgotUsername;
